import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

// Component
import AuthComponent from "../../components/Auth/AuthComponent";

// Services
import SplitForm from "../../components/SplitForm";
import { useDispatch } from "react-redux";
import { updateUser } from "../../store/reducers/currentUserSlice";
import axios from "../../services/axios/backendAxios";
import { AuthContext } from "../../AuthContext";

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const phone = searchParams.get("phone");

  const { tokenAvailable, authUser, authReady } = useContext(AuthContext);
  const authPhone = authUser?.phone_number;
  // True once we have seen this browser logged out on this page. After that, a
  // session that appears is a login that just happened here, not a leftover.
  const sawLoggedOut = useRef(false);
  // Phone number of a leftover session that has no account behind it
  const [noAccountPhone, setNoAccountPhone] = useState(null);

  useEffect(() => {
    if (authReady && !tokenAvailable) {
      sawLoggedOut.current = true;
    }
  }, [authReady, tokenAvailable]);

  useEffect(() => {
    if (tokenAvailable) {
      axios
        .get("user/me")
        .then((res) => {
          const user = res.data.user;
          dispatch(updateUser(user));
          console.log("sending you to the dashboard");
          navigate("/admin");
        })
        .catch((err) => {
          console.log(err);
          if (err.response?.status !== 404) {
            return;
          }
          if (sawLoggedOut.current) {
            // They just logged in here with a number that has no account yet.
            // Sign-up picks up the session and skips the second SMS code.
            navigate("/sign-up");
          } else {
            // A session was already here when the page opened (for example an
            // unfinished sign-up). They came to log in, and may want a
            // different number, so keep them here.
            setNoAccountPhone(authPhone ?? "");
          }
        });
    }
  }, [tokenAvailable, authPhone, navigate, dispatch]);

  return (
    <SplitForm>
      <div className="grid h-full">
        <div className="text-full-white place-self-center py-20">
          {noAccountPhone !== null ? (
            <div
              className="p-2 mb-4 border border-snow-red rounded"
              data-testid="admin-login-no-account"
            >
              This browser is still signed in as {noAccountPhone}, which has no
              account. Log in below with another number, or{" "}
              <Link to="/sign-up" className="underline">
                finish signing up
              </Link>
              .
            </div>
          ) : null}
          <AuthComponent
            subtext="Don't have an account? Sign Up."
            subtextUrl="/sign-up"
            title="Login"
            phone={phone}
            subtitle="Welcome back! Please enter your details."
          />
        </div>
      </div>
    </SplitForm>
  );
};

export default AdminLoginPage;
